import ReactSelect, { CSSObjectWithLabel, ControlProps, GroupBase, StylesConfig } from 'react-select';
import { logger } from '../../utils';
import { MAGNETIC_TOKENS } from '@appd/uik';

const {
  COLORS: { DEFAULT_BG, DEFAULT_TEXT, CONTROL_BORDER_ACTIVE, CONTROL_BORDER },
} = MAGNETIC_TOKENS;

interface SystemSelectProps {
  options?: { value: unknown }[];
  value?: unknown;
  onChange?: (value: unknown) => void;
}

export const SystemSelect = ({ options, value, onChange = () => {}, ...rest }: SystemSelectProps) => {
  const selectOptions = options ?? [];
  const defaultValue = Array.isArray(value)
    ? value.map(v => selectOptions.find((o: { value: unknown }) => o.value === v))
    : selectOptions.find((o: { value: unknown }) => o.value === value);
  logger.log('select defaultValue', value, defaultValue);
  const customStyles: StylesConfig<unknown, boolean, GroupBase<unknown>> = {
    input: () => ({
      color: DEFAULT_TEXT,
      width: '0px',
    }),
    placeholder: () => ({
      color: DEFAULT_TEXT,
    }),
    valueContainer: (base: CSSObjectWithLabel) => ({
      ...base,
      color: DEFAULT_TEXT,
      background: DEFAULT_BG,
      textOverflow: 'ellipsis',
      maxWidth: '90%',
      paddingRight: 0,
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'flex',
    }),
    control: (base: CSSObjectWithLabel, props: ControlProps<unknown, boolean, GroupBase<unknown>>) => ({
      ...base,
      color: DEFAULT_TEXT,
      background: DEFAULT_BG,
      borderColor: props.isFocused ? CONTROL_BORDER_ACTIVE : CONTROL_BORDER,
      '&:hover': {
        borderColor: CONTROL_BORDER_ACTIVE,
      },
    }),
    option: (base: CSSObjectWithLabel) => ({
      ...base,
      color: DEFAULT_TEXT,
      '&:hover': {
        background: CONTROL_BORDER_ACTIVE,
      },
    }),
    menu: (base: CSSObjectWithLabel) => ({
      ...base,
      borderRadius: 1,
      marginTop: -10,
      color: DEFAULT_TEXT,
      backgroundColor: DEFAULT_BG,
      border: '0',
      boxShadow: '0 10px 30px 0 #0000004d',
      width: 'calc(100% - 1em)',
      zIndex: 10,
    }),
  };
  return (
    <ReactSelect
      styles={customStyles}
      options={selectOptions}
      defaultValue={defaultValue}
      onChange={onChange}
      {...rest}
    />
  );
};
